<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="frontmatter Dedication" id="rw-frontmatter-Dedication_70539-172485987"><div class="block dedication" id="rw-block-dedication_70539-931699422"><p class="ded" id="rw-p_70539-259498508"><span>To Daniel, Regina, and Autumn Rose, with all of my love.</span></p></div></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781455522866_dedication.vue?3ff048f4